module.exports = __webpack_public_path__ + "img/HR-CV.e4d8ecc9.svg";